import React, { type ReactNode, createContext, useContext } from 'react';

type RenderMode = 'client' | 'static';

const ctx = createContext<RenderMode>('client');

const { Provider } = ctx;

interface Props {
  children: ReactNode;
  mode: RenderMode;
}

export const RenderModeProvider = ({ children, mode }: Props) => (
  <Provider value={mode}>{children}</Provider>
);

export const useRenderMode = () => useContext(ctx);
